<template>
  <link
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css"
    rel="stylesheet"
  />
  <div>
    <TransitionRoot as="template" :show="sidebarOpen">
      <Dialog
        as="div"
        class="relative z-50 xl:hidden"
        @close="sidebarOpen = false"
      >
        <TransitionChild
          as="template"
          enter="transition-opacity ease-linear duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <div class="fixed inset-0 bg-gray-900/80" />
        </TransitionChild>

        <div class="fixed inset-0 flex">
          <TransitionChild
            as="template"
            enter="transition ease-in-out duration-300 transform"
            enter-from="-translate-x-full"
            enter-to="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leave-from="translate-x-0"
            leave-to="-translate-x-full"
          >
            <DialogPanel class="relative flex w-full max-w-xs flex-1">
              <!-- Sidebar component -->
              <div class="absolute right-0 top-0 flex w-16 justify-center pt-5">
                <button
                  type="button"
                  class="-m-2.5 p-2.5"
                  @click="sidebarOpen = false"
                >
                  <span class="sr-only">Close sidebar</span>
                  <XMarkIcon class="h-6 w-6 text-gray-900" aria-hidden="true" />
                </button>
              </div>
              <div
                class="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 ring-1 ring-white/10"
              >
                <div class="flex h-16 shrink-0 items-center">
                  <router-link to="/admin">
                    <img src="/images/logo.svg" class="h-8 w-auto" />
                  </router-link>
                </div>
                <nav
                  v-if="userIsAdmin !== undefined && userIsWriter !== undefined"
                  class="grid grid-cols-1 gap-y-3 h-3/4"
                >
                  <LinkButton
                    v-show="userIsWriter || userIsAdmin || userIsOdin"
                    style-type="outline-complementary"
                    icon="plus"
                    text="Skapa annons"
                    :to="{
                      name: 'formbuilderPicker',
                    }"
                    class="-mt-1 w-full h-[2.5em] flex place-content-center bg-gradient-to-b from-orange-2 to-orange-4 shadow-md shadow-gray-2 hover:shadow-lg text-lg transition duration-300 ease-in-out transform hover:scale-105 text-white"
                  />
                  <Button
                    v-show="!userIsWriter && !userIsAdmin && !userIsOdin"
                    icon="plus"
                    text="Skapa annons"
                    class="text-lg py-2 px-5 border font-regular rounded-lg bg-stone-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:bg-opacity-50 flex items-center justify-center w-full h-[2.5em] text-stone-200 cursor-not-allowed"
                    >Skapa annons <i class="fas fa-plus ml-2"></i
                  ></Button>
                  <ul class="space-y-0.5">
                    <li
                      v-for="(category, i) in !userIsOdin
                        ? categories02
                        : categories03"
                      :key="i"
                    >
                      <p
                        class="inline-block text-xs px-3 uppercase text-darkGray-4"
                      >
                        <span
                          :class="{
                            'text-stone-300': !hasCategoryPermission(category),
                          }"
                        >
                          {{ category.category }}
                          <!-- Add the exclamation mark icon if user doesn't have permission -->
                          <i
                            v-if="!hasCategoryPermission(category)"
                            class="fas fa-exclamation-triangle text-xs ml-1 hover:text-orange-4"
                            title="Du har inte behörighet till kategori"
                          ></i>
                        </span>
                      </p>
                      <ul class="flex flex-col py-1.5 gap-2">
                        <li
                          v-for="item in category.items"
                          :key="item.link"
                          class="px-3 py-1.5 rounded-md"
                          v-if="!userIsOdin ? categories02 : categories03"
                        >
                          <router-link
                            :to="item.link"
                            @click.prevent="navigateToLink(item.link)"
                            :class="{
                              'text-stone-300 cursor-not-allowed': !isVisible(
                                item.link,
                                userIsAdmin,
                                userIsWriter
                              ),
                              'bg-blue-4 text-blue-1':
                                $route.fullPath === item.link, // Apply styling for the selected link
                              'text-darkGray-3 hover:bg-blue-4':
                                $route.fullPath !== item.link, // Apply styling for other links
                            }"
                          >
                            <div class="flex items-center justify-start">
                              <span
                                class="flex items-center justify-center flex-shrink-0 w-6 h-6"
                              >
                                <i
                                  :class="[
                                    navItemClass(item),
                                    'text-xl fas',
                                    item?.icon,
                                    {
                                      'text-stone-300': !isVisible(
                                        item.link,
                                        userIsAdmin,
                                        userIsWriter
                                      ),
                                    },
                                  ]"
                                ></i>
                              </span>
                              <span
                                class="inline-block ml-3 text-sm truncate"
                                >{{ item.name }}</span
                              >
                            </div>
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <ul class="relative mt-auto py-1.5 space-y-2">
                    <li
                      class="flex items-center transition rounded-lg group shrink-0"
                    >
                      <p
                        class="ml-2 text-xs text-left sm:block truncate"
                        v-if="store.state.userStore.token !== null"
                      >
                        <strong class="block font-medium truncate"
                          >{{
                            store.state.userStore.token?.decoded?.given_name
                          }}
                          {{
                            store.state.userStore.token?.decoded?.family_name
                          }}
                          ({{ store.getters.container?.name }})</strong
                        >

                        <span class="text-darkGray-4">
                          {{ store.state.userStore.token?.decoded?.sub }}
                        </span>
                      </p>
                      <div class="ml-auto flex items-center text-gray-600">
                        <button
                          v-if="store.getters.containers.length > 1"
                          @click="onPickContainer"
                          class="hover:text-gray-900"
                          title="Byt företag"
                        >
                          <i class="fas fa-building"></i>
                        </button>
                        <button
                          @click="onChangePassword"
                          class="ml-2 hover:text-gray-900"
                          title="Byt Lösenord"
                        >
                          <i class="fas fa-key"></i>
                        </button>
                        <button
                          @click="onLogout"
                          class="ml-2 hover:text-gray-900"
                          title="Logga ut"
                        >
                          <i class="fas fa-sign-out-alt"></i>
                        </button>
                      </div>
                    </li>
                  </ul>
                </nav>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>

    <!-- Static sidebar for desktop -->
    <div
      class="hidden xl:fixed xl:inset-y-0 xl:z-50 xl:flex xl:w-72 xl:flex-col"
    >
      <div
        class="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 ring-1 ring-white/5"
      >
        <div class="flex h-16 shrink-0 items-center justify-between">
          <router-link to="/admin">
            <img src="/images/logo.svg" alt="logo" class="h-8 w-auto" />
          </router-link>
          <!-- Knapp för att öppna eller stänga menyn -->
          <!-- <button type="button" class="p-2.5 text-darkGray-1"
            @click="toggleSidebar">
            <i :class="[!sidebarOpen ? 'fas fa-chevron-left' : 'fas fa-chevron-right']"></i>
          </button> -->
        </div>
        <nav
          class="flex flex-1 flex-col"
          v-if="userIsAdmin !== undefined && userIsWriter !== undefined"
        >
          <div>
            <LinkButton
              v-show="userIsWriter || userIsAdmin || userIsOdin"
              style-type="outline-complementary"
              icon="plus"
              text="Skapa annons"
              :to="{
                name: 'formbuilderPicker',
              }"
              class="-mt-1 w-full h-[2.5em] mb-[1em] flex place-content-center bg-gradient-to-b from-orange-2 to-orange-4 shadow-md shadow-gray-2 hover:shadow-lg text-lg transition duration-300 ease-in-out transform hover:scale-105 text-white"
            />
            <Button
              v-show="!userIsWriter && !userIsAdmin && !userIsOdin"
              icon="plus"
              text="Skapa annons"
              class="text-lg py-2 px-5 mb-[1em] border font-regular rounded-lg bg-stone-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:bg-opacity-50 flex items-center justify-center w-full h-[2.5em] text-stone-200 cursor-not-allowed"
              >Skapa annons <i class="fas fa-plus ml-2"></i
            ></Button>
          </div>
          <ul class="space-y-0.5">
            <li
              v-for="(category, i) in !userIsOdin ? categories02 : categories03"
              :key="i"
            >
              <p class="inline-block text-xs px-3 uppercase text-darkGray-4">
                <span
                  :class="{
                    'text-stone-300': !hasCategoryPermission(category),
                  }"
                >
                  {{ category.category }}
                  <!-- Add the exclamation mark icon if user doesn't have permission -->
                  <i
                    v-if="!hasCategoryPermission(category)"
                    class="fas fa-exclamation-triangle text-xs ml-1 text-orange-4 text-opacity-50 hover:text-orange-4"
                    title="Du har inte behörighet till den här kategorin"
                  ></i>
                </span>
              </p>
              <ul class="flex flex-col py-1.5 gap-2 pb-4">
                <li
                  v-for="item in category.items"
                  :key="item.link"
                  class="px-3 py-1.5 rounded-md"
                  v-if="!userIsOdin ? categories02 : categories03"
                >
                  <router-link
                    :to="item.link"
                    @click.prevent="navigateToLink(item.link)"
                    :class="{
                      'text-stone-300 cursor-not-allowed': !isVisible(
                        item.link,
                        userIsAdmin,
                        userIsWriter
                      ),
                      'bg-blue-4 text-blue-1': $route.fullPath === item.link,
                      'text-darkGray-3 hover:bg-blue-4':
                        $route.fullPath !== item.link,
                    }"
                  >
                    <div class="flex items-center justify-start">
                      <span
                        class="flex items-center justify-center flex-shrink-0 w-6 h-6"
                      >
                        <i
                          :class="[
                            navItemClass(item),
                            'text-xl fas',
                            item?.icon,
                            {
                              'text-stone-300': !isVisible(
                                item.link,
                                userIsAdmin,
                                userIsWriter
                              ),
                            },
                          ]"
                        ></i>
                      </span>
                      <span class="inline-block ml-3 text-sm truncate">{{
                        item.name
                      }}</span>
                    </div>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="xl:pl-72">
      <!-- Sticky search header -->
      <div
        class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-6 border-b border-white/5 bg-white px-4 shadow-sm sm:px-6 lg:px-8"
      >
        <button
          type="button"
          class="-m-2.5 p-2.5 text-gray-800 xl:hidden"
          @click="sidebarOpen = true"
        >
          <span class="sr-only">Open sidebar</span>
          <Bars3Icon class="text-gray-500 h-5 w-5" aria-hidden="true" />
        </button>

        <div class="block w-full">
          <GeneralSearch />
        </div>
        <div
          v-if="isDevOrStaging"
          class="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20 truncate sm:min-w-max"
        >
          <p class="truncate">Testmiljö - ej riktig data</p>
        </div>

        <div class="hidden xl:flex items-center justify-end gap-2">
          <NotificationsView />

          <Menu as="div" class="relative">
            <div>
              <MenuButton
                class="flex items-center transition rounded-lg group shrink-0"
              >
                <p
                  class="ml-2 text-xs text-left sm:block"
                  v-if="store.state.userStore.token !== null"
                >
                  <strong class="block font-medium truncate"
                    >{{ store.state.userStore.token?.decoded?.given_name }}
                    {{ store.state.userStore.token?.decoded?.family_name }}
                    ({{ store.getters.container?.name }})</strong
                  >

                  <span class="text-darkGray-4">
                    {{ store.state.userStore.token?.decoded?.sub }}
                  </span>
                </p>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-5 h-5 ml-2 text-darkGray-2 transition sm:block group-hover:text-darkGray-1"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </MenuButton>
            </div>

            <transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-75 ease-in"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0"
            >
              <MenuItems
                class="absolute right-0 mt-2 w-56 origin-top-right divide-y text-gray-600 divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden"
              >
                <MenuItem v-slot="{ active }">
                  <router-link
                    to="/admin/profile"
                    :class="[
                      active ? 'bg-gray-100 text-gray-900' : 'bg-white',
                      'group flex w-full items-center px-2 py-2 text-sm transition group gap-x-3 p-2 leading-6',
                    ]"
                  >
                    <div class="h-6 w-6 shrink-0" aria-hidden="true">
                      <i class="fas fa-user-cog"></i>
                    </div>
                    <p>Profilinställningar</p>
                  </router-link>
                </MenuItem>
                <MenuItem
                  v-slot="{ active }"
                  v-if="store.getters.containers.length > 1"
                >
                  <button
                    @click="onPickContainer"
                    :class="[
                      active ? 'bg-gray-100 text-gray-900' : 'bg-white',
                      'group flex w-full items-center px-2 py-2 text-sm transition group gap-x-3 p-2 leading-6',
                    ]"
                  >
                    <div class="h-6 w-6 shrink-0" aria-hidden="true">
                      <i class="fas fa-building"></i>
                    </div>
                    <p>Byt företag</p>
                  </button>
                </MenuItem>
                <MenuItem v-slot="{ active }">
                  <button
                    @click="onChangePassword"
                    :class="[
                      active ? 'bg-gray-100 text-gray-900' : 'bg-white',
                      'group flex w-full items-center px-2 py-2 text-sm transition group gap-x-3 p-2 leading-6',
                    ]"
                  >
                    <div class="h-6 w-6 shrink-0" aria-hidden="true">
                      <i class="fas fa-key"></i>
                    </div>
                    <p>Byt lösenord</p>
                  </button>
                </MenuItem>
                <MenuItem v-slot="{ active }">
                  <button
                    @click="onLogout"
                    :class="[
                      active ? 'bg-gray-100 text-gray-900' : 'bg-white',
                      'group flex w-full items-center px-2 py-2 text-sm transition group gap-x-3 p-2 leading-6',
                    ]"
                  >
                    <div class="h-6 w-6 shrink-0" aria-hidden="true">
                      <i class="fas fa-sign-out-alt"></i>
                    </div>
                    <p>Logga ut</p>
                  </button>
                </MenuItem>
              </MenuItems>
            </transition>
          </Menu>
        </div>
      </div>
      <main class="bg-blue-4 min-h-[calc(100vh-4rem)] p-4 md:p-6 lg:p-8">
        <slot />
        <vue-notification-list position="bottom-right"></vue-notification-list>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from "vuex";
import { computed, onMounted, reactive, ref, watch } from "vue";

import { Profile } from "@/models/Profile";
import { navItems, isVisible, navItemClass } from "@/models/Navigation";
import { imageDoesExist } from "@/utils/getImages";
import { useRouter } from "vue-router";
import { XMarkIcon } from "@heroicons/vue/24/outline";
import { Bars3Icon } from "@heroicons/vue/20/solid";
import "reflect-metadata";

import {
  Menu,
  MenuButton,
  MenuItems,
  MenuItem,
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import GeneralSearch from "@/features/shared/components/ui/GeneralSearch.vue";
import { TYPES } from "@/types";
import { myContainer } from "@/inversify.config";
import LinkButton from "@/features/shared/components/ui/LinkButton.vue";
import NotificationsView from "@/features/notifications/views/NotificationsView.vue";
import { ISignalRService } from "@/interfaces/ISignalR";
const store = useStore();
const signalRClient = myContainer.get<ISignalRService>(TYPES.ISignalRService);
const profile = ref({} as Profile);
const isLoaded = ref(false);
const router = useRouter();
const host = window.location.host;
const parts = host.split(".");
const subdomain = parts[0];
const isDevOrStaging =
  subdomain.includes("min-dev") || subdomain.includes("min-staging");

const toggleSidebar = () => {
  sidebarOpen.value = !sidebarOpen.value;
  const sidebar = document.querySelector(
    ".xl\\:fixed.xl\\:inset-y-0.xl\\:z-50.xl\\:flex.xl\\:w-72.xl\\:flex-col"
  );
  if (sidebar) {
    if (sidebarOpen.value) {
      sidebar.classList.remove("hidden");
    } else {
      sidebar.classList.add("hidden");
    }
  }
};

const onPickContainer = () => {
  store.dispatch("resetContainer");
  router.push("/admin/pick-container");
};

const onLogout = async () => {
  await store.dispatch("logout");
  router.push("/admin/login");
};

const onChangePassword = () => {
  router.push("/admin/change-password");
};

watch(
  () => store.getters.container.id,
  () => {
    init();
  }
);

watch(
  () => router.currentRoute.value.name,
  () => {
    sidebarOpen.value = false;
  }
);

const userIsWriter = ref(false);
const userIsAdmin = ref(false);
const userIsOdin = ref(false);
const profileHasLogo = ref(false);
const sidebarOpen = ref(false);

const roles = reactive({
  userIsWriter,
  userIsAdmin,
  userIsOdin,
});

onMounted(async () => {
  await store.dispatch("decodeToken");
  if (store.getters.container.id) {
    await store.dispatch("init");
  }
  init();
});

const init = async () => {
  userIsAdmin.value = await store.dispatch("loggedInUserIsAdmin");
  userIsWriter.value = await store.dispatch("loggedInUserIsWriter");
  userIsOdin.value = await store.dispatch("loggedInUserIsOdin");
  profileHasLogo.value = await imageDoesExist(profile.value.Logo);
  isLoaded.value = true;
};

const navigateToLink = (link: string) => {
  if (isVisible(link, roles.userIsAdmin, roles.userIsWriter)) {
    // Navigera bara om länken är synlig och användbar
    router.push(link);
  }
};

const hasCategoryPermission = (category: any) => {
  // Adjust the condition based on your permission logic
  if (category.category === "Inställningar") {
    // Check if the user is a writer
    return userIsWriter.value;
  } else if (category.category === "Admin" && "Inställningar") {
    // Check if the user is an admin
    return userIsAdmin.value;
  } else if (category.category === "Admin" && "Inställningar" && "Superuser") {
    // Check if the user is an Odin
    return userIsOdin.value;
  } else {
    return true; // Default to true for other categories
  }
};

const showCategories02 = (categories: any[]): any[] => {
  return categories.filter((category) =>
    ["Allmänt", "Inställningar", "Admin"].includes(category.category)
  );
};
const showCategories03 = (categories: any[]): any[] => {
  return categories.filter((category) =>
    ["Allmänt", "Inställningar", "Admin", "Superuser"].includes(
      category.category
    )
  );
};

const categories02 = showCategories02(navItems);
const categories03 = showCategories03(navItems);
</script>

<style>
.metallic-button {
  border: none;
  outline: none;
  /* max-height:50px; */
  background: linear-gradient(
    45deg,
    #ca6c01e0 5%,
    /* Mörkast */ #e8a43de0 10%,
    /* Ljusaste */ #cf7901ee 30%,
    /* Näst mörkast*/ #e2a44c 50%,
    /* Näst ljusast*/ #cf7901e5 70%,
    /* Näst mörkast*/ #e8a43de9 80%,
    /* Ljusaste */ #bd6500e2 95% /* Mörkast */
  );
  text-shadow: 1.5px 1.5px 3.5px rgba(56, 56, 56, 0.501);
  font-weight: 500;
  letter-spacing: 0.5px;
  cursor: pointer;
}
</style>
